import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarSeparator,
} from '@/components/ui/sidebar'
import { cn } from '@/lib/utils'
import { navGroups, ProductTab } from './prototypeNav'

interface NavRowsProps {
  tab: ProductTab
  /** The row showing in the main area, or null for the dashboard. */
  page: string | null
  /** Only ever a row title — the dashboard is reached from outside the nav. */
  onNavigate: (page: string) => void
  /** Icons only — the labels and group headings fold away. */
  collapsed?: boolean
}

/** The selected product's rows, grouped the way the real nav groups them. */
export function NavRows({ tab, page, onNavigate, collapsed }: NavRowsProps) {
  return (
    <>
      {navGroups(tab).map((group, index) => (
        <div key={group.label ?? `group-${index}`}>
          {index > 0 && <SidebarSeparator className="bg-border" />}
          <SidebarGroup className={cn('py-3', collapsed && 'px-1')}>
            {group.label && !collapsed && (
              <SidebarGroupLabel className="h-5 pb-1 text-[10px]">{group.label}</SidebarGroupLabel>
            )}
            <SidebarGroupContent>
              <SidebarMenu className="gap-0.5">
                {group.rows.map((row) => {
                  const Icon = row.icon
                  const active = row.title === page
                  return (
                    <SidebarMenuItem key={row.title}>
                      <SidebarMenuButton
                        onClick={() => onNavigate(row.title)}
                        isActive={active}
                        tooltip={collapsed ? row.title : undefined}
                        className={cn('text-xs', collapsed && 'justify-center', active && 'font-semibold')}
                      >
                        <Icon color={active ? 'var(--color-ink-900)' : 'var(--color-ink-300)'} />
                        {!collapsed && <span>{row.title}</span>}
                      </SidebarMenuButton>
                    </SidebarMenuItem>
                  )
                })}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        </div>
      ))}
    </>
  )
}
